var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget widget-tags"},[(_vm.hotTagList.length > 0)?_c('h4',{staticClass:"widget-title"},[_vm._v("熱門標籤")]):_vm._e(),_c('div',{staticClass:"tags"},[_vm._l((_vm.hotTagList),function(tag,index){return [_c('router-link',{key:index,attrs:{"to":{
                path: '/tag',
                query: { q: tag.name }
          }},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_vm._v(" "+_vm._s(tag.name)+" ")])]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }